import axios from '../axiosInstance';

/**
 * DataGrid-style query for enabled trailers (keyset pagination, sort, filter).
 * Backend: POST api/Trailers/queryEnabled
 * Returns: { items, cursor, hasMore }
 */
export async function queryEnabledTrailers({
    search,
    pageSize,
    cursor,
    sortBy,
    sortDir,
    filterModel,
    signal = null,
} = {}) {
    const body = {
        search: search ?? null,
        pageSize,
        cursor: cursor ?? null,
        sortBy: sortBy ?? 'vehicleReg',
        sortDir: sortDir ?? 'asc',
        filterModel: filterModel ?? { items: [], logicOperator: 'and' },
    };

    const { data } = await axios.post('/Trailers/queryEnabled', body, { signal });
    return data;
}

// GET enabled, paginated (kept for route loader / lookups). Stopped != 'T'
export async function getTrailersEnabled({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Trailers/getEnabled', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}

export async function getTrailerById(id, signal = null) {
    const { data } = await axios.get(`/Trailers/${id}`, { signal });
    return data;
}

export async function createTrailer(payload, signal = null) {
    const { data } = await axios.post('/Trailers', payload, { signal });
    return data; // e.g., { id }
}

export async function updateTrailer(id, payload, signal = null) {
    await axios.put(`/Trailers/${id}`, payload, { signal });
    return true;
}

export async function deleteTrailer(id, signal = null) {
    const { data } = await axios.delete(`/Trailers/${id}`, { signal });
    return data;
}

export async function saveTrailerTare(id, { weight, reason = null, signal = null } = {}) {
    const { data } = await axios.post('/Tares/saveForTrailer', { id: Number(id), weight, reason }, { signal });
    return data;
}
